import { ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select, Store } from '@ngxs/store';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { BaseControlDirective } from '../../directives/base-control.directive';
import { IInventoryLocation } from '../../interfaces/inventory-location.interface';
import { InventoryState } from '../../states/inventory/inventory.state';
import { PharmacyState } from '../../states/pharmacy/pharmacy.state';

@UntilDestroy()
@Component({
  selector: 'app-inventory-locations-dropdown',
  templateUrl: './inventory-locations-dropdown.component.html',
  styleUrls: ['./inventory-locations-dropdown.component.scss'],
  providers: [
    {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => InventoryLocationsDropdownComponent), multi: true},
    {provide: NG_VALIDATORS, useExisting: forwardRef(() => InventoryLocationsDropdownComponent), multi: true},
  ],
})
export class InventoryLocationsDropdownComponent extends BaseControlDirective implements OnInit, OnChanges {

  @Input() label: string;
  @Input() formControl: FormControl;
  @Input() showDescription: boolean;
  @Input() excludeOptions: string[];
  @Input() positiveInventoryBalanceLocationIDs: string[];
  @Input() autoSelectSingleOption: boolean;
  
  @Output() optionChosen: EventEmitter<IInventoryLocation> = new EventEmitter();

  @ViewChild('dropDown') dropDown;

  filteredInventoryLocations$: BehaviorSubject<IInventoryLocation[]> = new BehaviorSubject([]);

  @Select(PharmacyState.inventoryLocationsEnabled) inventoryLocationsEnabled$: Observable<boolean>;
  @Select(InventoryState.activeLocations) inventoryLocations$: Observable<IInventoryLocation[]>;
  @Select(InventoryState.loading) loading$: Observable<boolean>;
  /**
   *
   */
  constructor(private store: Store) {
    super();
  }
  ngOnChanges(changes: SimpleChanges): void {
    const filtered = this.store.selectSnapshot(InventoryState.activeLocations)
    ?.filter(this.filterOutLocationsWithPositiveInventoryPredicate.bind(this))
    ?.filter(this.filterOutExcludedLocationsPredicate.bind(this));
    if (filtered.length === 1 && this.autoSelectSingleOption) {
      this.formControl.setValue(filtered[0].id, {emitEvent: false});
    }
    this.filteredInventoryLocations$.next(filtered); 
  }

  ngOnInit(): void {
    this.inventoryLocations$
    .pipe(untilDestroyed(this), distinctUntilChanged())
    .subscribe(locations => {
       return this.filteredInventoryLocations$.next(
        locations
        ?.filter(this.filterOutLocationsWithPositiveInventoryPredicate.bind(this))
        ?.filter(this.filterOutExcludedLocationsPredicate.bind(this))
      );
    });
  }

  focus(): void {
    this.dropDown?.focus();
  }

  private filterOutExcludedLocationsPredicate(x: IInventoryLocation): boolean {
    return !this.excludeOptions?.includes(x.id);
  }

  private filterOutLocationsWithPositiveInventoryPredicate(x: IInventoryLocation): boolean {
    if(!this.positiveInventoryBalanceLocationIDs?.length) {
      return true;
    }
    return this.positiveInventoryBalanceLocationIDs?.includes(x.id);
  }
  
}
